export default function (Component) {
Component.options.__docs = "<p>Calendars work best when displayed in a popover. You can use <code>FdPopover</code> for that.</p>\n"
}